import React, { useEffect } from "react";
import banner from "../Assets/Images/homebanner.jpg";
import { Link } from "react-router-dom";
function Aboutus() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <section>
        <div
          className="bannerimg cover-image bg-background3"
          data-bs-image-src={banner}
          style={{ background: `url(${banner}) center 25%` }}
        >
          <div className="header-text mb-0">
            <div className="container">
              <div className="text-center text-white">
                <h1>Our Story: Why We Built Happie Dealz</h1>
                <ol className="breadcrumb text-center">
                  <li className="breadcrumb-item">
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li className="breadcrumb-item active text-white">
                    About us
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="sptb">
        <div class="container">
          <div class="text-justify">
            <h2 class="mb-4 text-bold">Marketing Should Be Simple and Direct</h2>
            <p class="leading-normal">
              Accessing the right marketing expertise has become unnecessarily complex. Businesses
              often navigate fragmented platforms, intermediaries, and high recurring costs just to
              connect with the right marketing professionals. At the same time, skilled freelance
              marketers face limited visibility, restrictive systems, and platforms that control how
              connections are made.
            </p>
            <p>We saw that the real challenge was not a lack of talent or opportunity — it was the
              system in between.</p>
            <p>So, we built Happie Dealz: a global marketing platform designed to simplify how
              businesses and freelance marketers find each other and collaborate. By removing
              unnecessary intermediaries, Happie Dealz enables direct connections through a simple
              subscription model — allowing both sides to work together on their own terms.</p>
            <p>Our purpose is clear: to create a dedicated, transparent space where meaningful
              marketing partnerships can begin quickly and naturally, without platform interference.</p>

            <h2 class="mb-4 text-bold">Our Vision: Empowering Work Freedom and Global Reach</h2>
            <p class="leading-normal fs-18">
              We believe talent and opportunity should never be limited by geography, rigid
              structures, or unnecessary complexity. Our vision goes beyond listings or automated
              matching. We are building a global ecosystem where independent professionals and
              businesses can connect directly and collaborate with clarity and confidence.
            </p>
            <p><b>For the Marketer:</b> Happie Dealz supports independent work by enabling marketers to
              choose projects across industries, set their own terms, and build long-term professional
              relationships with businesses worldwide</p>
            <p><b>For the Business:</b> Happie Dealz offers a direct, subscription-based way to access
              marketing expertise globally — without recurring recruitment costs or platform-controlled
              transactions.</p>
            <h2 class="mb-4 text-bold">Our Core Values</h2>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th className="bg-primary text-white text-bold">Core Value</th>
                  <th className="bg-primary text-white text-bold">Our Promise to You</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="bg-primary text-white text-bold">Simplicity</td>
                  <td>We remove complexity from the process. Happie Dealz is
                    designed to make discovering opportunities, connecting with
                    the right people, and collaborating straightforward and
                    efficient.</td>
                </tr>
                <tr>
                  <td className="bg-primary text-white text-bold">Transparency</td>
                  <td>Clear subscription pricing, no hidden charges, and full
                    independence in how businesses and marketers work
                    together.</td>
                </tr>
                <tr>
                  <td className="bg-primary text-white text-bold">Focus</td>
                  <td>Built exclusively for marketing connections, ensuring
                    relevance, clarity, and meaningful collaborations for all users.</td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </section>

    </>
  );
}

export default Aboutus;
